import { z } from 'zod';

export const ChangeDueDateModalSchema = z.object({
  dueDate: z.date({ message: 'กรุณาระบุวันครบกำหนด' }),
});

export type ChangeDueDateModalFormValues = z.infer<typeof ChangeDueDateModalSchema>;
